import { render, staticRenderFns } from "./personTagAboutPerson.vue?vue&type=template&id=7025e248&"
import script from "./personTagAboutPerson.vue?vue&type=script&lang=js&"
export * from "./personTagAboutPerson.vue?vue&type=script&lang=js&"
import style0 from "./personTagAboutPerson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports